<template>
    <section class="content p-5 column">
        <form class="form" method="POST" @submit="sendData" ref="form">
            <label for="inputPassword5" class="form-label">Токен</label>
            <input ref="password" type="password" autocomplete="on" class="form-control" aria-describedby="passwordHelpBlock">
            <button class="btn btn-success">Отправить</button>
        </form>
    </section>
</template>

<script>
import axios from 'axios';
import store from '../store.js'
export default {
    mounted() {
        if(localStorage.getItem('refresh') && localStorage.getItem('access')) {
            axios.post('https://dev.fly7.ru/mb600/hs/dash/login/refresh_token', {
                refresh: localStorage.getItem('refresh')
            }).then(response => {
                localStorage.setItem('refresh', response.data.refresh);
                localStorage.setItem('access', response.data.access)

                store.commit('login')

                this.$router.push('/board/overview')
            }).catch(error => {
                console.log(error)

                localStorage.removeItem('refresh', response.data.refresh);
                localStorage.removeItem('access', response.data.access)
            })
        }
    },  
    methods: {
        sendData(e) {
            e.preventDefault()
            let api = axios.create()

            api.interceptors.response.use(
            response => {
                console.log(response)
                localStorage.setItem('access', response.data.access)
                localStorage.setItem('refresh', response.data.refresh)

                store.commit('login')

                this.$router.push('/board/overview')
            },
            error => {
                console.log(error)
                if(error.response.data = "токен не найден") {
                    alert('Не верный токен!')
                }
            })
            
            api.post(
                'https://dev.fly7.ru/mb600/hs/dash/login/token',
                {
                    AuthKey: this.$refs.password.value
                }
            )
        }
    }
}
</script>

<style lang="sass" scoped>
.content    
    display: flex
    align-items: center
    height: 100vh
    justify-content: center
    background: #6c757d
.form
    display: flex
    justify-content: center
    flex-direction: column
    align-items: center
    background: white   
    max-width: 300px
    width: 100%
    padding: 30px
    border-radius: 25px
.form-control
    background: #d6dce2
.btn
    margin-top: 15px
    
</style>